import { Component, OnInit, Input, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { CardPresentationComponent } from 'app/core/components/workflow-new/common/card-presentation';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'itpx-evaluation-deliverable-tile-uptodate',
  templateUrl: './evaluation-deliverable-tile-uptodate.component.html',
  styleUrls: ['../../../workflow-new/common/style.css']
})
export class EvaluationDeliverableTileUptodateComponent extends CardPresentationComponent implements OnInit {
  @Input('props') properties: { props: any, conf: MaterialConfiguration };
  @Input() state$: Observable<any>;
  @Input() assignmentId: string;
  private sharedState$: Observable<any>;
  private tagType: string;
  private expired: boolean;
  private supplements: string;
  private imageWidth: string;
  private imageHeight: string;
  private cardHeight: string;
  private cardWidth: string;
  private thumbnail: string;
  private props: any;
  public conf: MaterialConfiguration;
  private readonly downloadableMaterial: string[] = ['ebook', 'ispring', 'archive'];
  private completedCourses: number;
  private totalCourses: number = 1;

  constructor(private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.sharedState$ = this.state$.shareReplay(1);
    Object.assign(this, this.properties);
    Object.assign(this, this.conf);
    this.update(this.props, true);
    this.completedCourses = this.props.contents && this.props.contents[0] && +this.props.contents[0].coursePercentage === 100 ? 1 : 0;
    this.sharedState$.bindToLifecycle(this).subscribe(res => {
      this.conf.clickable = res.enabled;
      if (this.downloadableMaterial.includes(res.type.toLowerCase()) && res.googleEmbedLink)
        this.conf.links[0].url = [res.googleEmbedLink];
        // this.conf.target = [res.googleEmbedLink]
    });
  }

  isOnlineMaterial(type: string): boolean {
    return type === 'scormcloud' || type === 'scorm' || type === 'video' 
    || type === 'googleslides' || type ==='scorm-content' || type === 'presentation';
  }

  update(deliverable: any, createTarget: boolean) {
    if (!deliverable.contents || !this.isOnlineMaterial(deliverable.contents[0].type.configKey || deliverable.contents[0].type))
      return;
    //TODO: name can be null ???
    // this.name = deliverable.name || 'Learning Material';
    if (createTarget) {
      if ('scormcloud' === deliverable.type)
      this.conf.target = ['evaluation', deliverable.type, deliverable.contents[0].scormCloudTokenId];
      else
      this.conf.target = ['evaluation', deliverable.type, this.assignmentId, deliverable.contents[0].id];
    }
    this.conf.action = LinkActions.REDIRECT;
    this.conf.links[0].url = this.conf.target;
  }

}


// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-deliverable-tile-uptodate/evaluation-deliverable-tile-uptodate.component.ts